const MOBILE_DASHBOARD_SITE_IDS: number[] = [2];

export default MOBILE_DASHBOARD_SITE_IDS;
